import React, { useEffect } from 'react';
import { FullStory } from '@fullstory/browser';
import { useAppSelector } from '../../hooks/useAppSelector';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import * as userSlice from '../../data/user.slice';
import * as lookupSlice from '../../data/lookup.slice';
import { useLocation } from 'react-router-dom';
import { useIsClientPortalUser } from '../../hooks/useIsClientPortalUser';
import { useIsClientPortalAdminUser } from '../../hooks/useIsClientPortalAdminUser';
import BaseLayout from '../../containers/member/BaseLayout';
import MemberLayout from '../../containers/member/MemberLayout';
import ClientLayout from '../../containers/member/ClientLayout';
import './assets/css/styles.css';

export default function MemberPortal() {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(userSlice.selectLoggedInUserInfo);
  const isClientPortalUser = useIsClientPortalUser();
  const isClientPortalAdminUser = useIsClientPortalAdminUser();
  const isClientUser = isClientPortalUser || isClientPortalAdminUser;

  useEffect(() => {
    document.querySelector('header')?.scrollIntoView();
  }, [pathname]);

  React.useEffect(() => {
    if (userInfo?.emailAddress) {
      FullStory('setProperties', {
        type: 'user',
        properties: {
          email: userInfo.emailAddress,
        },
      });
    }
  }, [userInfo?.emailAddress]);

  React.useEffect(() => {
    if (isClientUser) {
      dispatch(lookupSlice.fetchLookupItemsAsync('timeZone'));
      dispatch(lookupSlice.fetchLookupItemsAsync('tripMode'));
      dispatch(lookupSlice.fetchLookupItemsAsync('passengerCareLevel'));
      dispatch(lookupSlice.fetchLookupItemsAsync('tripLegPassengerNoteType'));
      dispatch(lookupSlice.fetchLookupItemsAsync('tripLegPassengerNoteType'));
      dispatch(lookupSlice.fetchLookupItemsAsync('tripLegDriverNoteType'));
      dispatch(lookupSlice.fetchLookupItemsAsync('alternateContactType'));
      dispatch(lookupSlice.fetchLookupItemsAsync('stateCodeList'));
      dispatch(lookupSlice.fetchLookupItemsAsync('clientVertical'));
      dispatch(lookupSlice.fetchLookupItemsAsync('clientContactDepartment'));
      dispatch(lookupSlice.fetchLookupItemsAsync('clientContactRole'));
      dispatch(lookupSlice.fetchLookupItemsAsync('clientAddressUse'));
      dispatch(lookupSlice.fetchLookupItemsAsync('tripLegOverrideReason'));
      dispatch(lookupSlice.fetchLookupItemsAsync('tripLegStatusReason'));
      dispatch(lookupSlice.fetchLookupItemsAsync('purposeCodeCategory'));
      dispatch(lookupSlice.fetchLookupItemsAsync('clientSettingOption'));
      dispatch(lookupSlice.fetchTransportationAttributeMapAsync());
    }
  }, [isClientUser, dispatch]);

  return (
    <BaseLayout>
      {isClientUser ? <ClientLayout /> : <MemberLayout />}
    </BaseLayout>
  );
}
